import React, { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import SentimentDissatisfiedOutlined from "@mui/icons-material/SentimentDissatisfiedOutlined";
import Typography from "@mui/material/Typography";
import { LoginAction } from "../components";
import ErrorPage from "../ErrorPage/ErrorPage";
const AccessDeniedPage = ({ errorAction = React.createElement(LoginAction, null) }) => {
    const { t } = useTranslation("errorPages");
    return (React.createElement(ErrorPage, { title: t("403.title", ""), subtitle: t("403.subtitle", ""), icon: React.createElement(SentimentDissatisfiedOutlined, null) },
        React.createElement(Trans, { i18nKey: "403.description", t: t },
            React.createElement(Typography, { paragraph: true }),
            React.createElement(Typography, null)),
        errorAction));
};
export default memo((props) => React.createElement(AccessDeniedPage, { ...props }));
//# sourceMappingURL=AccessDeniedPage.js.map